import { styled } from '$utils/theme'
import { Block } from '$views/components'
import { rem } from 'polished'
import { keyframes } from 'styled-components'

const Bouncedelay = keyframes`
    0% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    80% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
`

export const SpinnerWrapper = styled(Block)`
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
  background-color: rgba(256, 256, 256, 0.75);
  z-index: 2;
`

export const HorizontalSpinnerWrapper = styled.div`
  width: 70px;
  text-align: center;
  > div {
    width: 12px;
    height: 12px;
    background-color: ${p => p.theme.colors.darkGrey};

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: ${Bouncedelay} 1.4s infinite ease-in-out both;
    animation: ${Bouncedelay} 1.4s infinite ease-in-out both;
  }
`

export const SpinnerBounce1 = styled.div`
  -webkit-animation-delay: 0.32s !important;
  animation-delay: 0.32s !important;
  margin-right: ${p => rem(p.theme.sizes.tiny)};
`

export const SpinnerBounce2 = styled.div`
  -webkit-animation-delay: 0.16s !important;
  animation-delay: 0.16s !important;
  margin-right: ${p => rem(p.theme.sizes.tiny)};
`



// WEBPACK FOOTER //
// ./src/views/components/Spinner/Spinner.style.ts